import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { env } from '../../../app.constant';
import { tap } from 'rxjs/operators';
// import { AccountData, AccountForm, ApiResponse, fetchAdjustmentForm } from '../../data/system/account';

@Injectable()
export class CaaService {

  constructor(private http: HttpClient) {
    // 
  }

  save(param: any): Observable<any> {
    const host = `${env.host}${env.endpoint.caa_save}`;
    return this.http.post<any>(host, param).pipe(
      tap(data => {
        console.log(`caa->save->data`, data);
      })
    );
  }

  fetch(param: any): Observable<any> {
    const host = `${env.host}${env.endpoint.caa_fetch}`;
    return this.http.post<any>(host, param).pipe(
      tap(data => console.log(`caa->fetch->data`, data))
    );
  }

  lists(param: any): Observable<any> {
    const host = `${env.host}${env.endpoint.caa_lists}`;
    return this.http.post<any>(host, param).pipe(
      tap(data => console.log(`caa->lists->data`, data))
    );
  }

  delete(id: number): Observable<any> {
    const host = `${env.host}${env.endpoint.caa_delete}`;
    return this.http.post<any>(host, { id }).pipe(
      tap(data => console.log(`caa->delete->data`, data))
    );
  }

  find(id: number): Observable<any> {
    const endpoint = env.endpoint.caa_find.replace(":id", String(id));
    const host = `${env.host}${endpoint}`;
    return this.http.get<any>(host).pipe(
      tap(data => console.log(`caa->find->data`, data))
    );
  }

  update(param: any): Observable<any> {
    const host = `${env.host}${env.endpoint.caa_update}`;
    return this.http.post<any>(host, param).pipe(
      tap(data => {
        console.log(`caa->update->data`, data);
      })
    );
  }

  updateStatus(data: any): Observable<any> {
    const host = `${env.host}/caa/update-status`;
    return this.http.post<any>(host, data);
}
}